import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* uploadv3(action) {
  var payload = {
    action: "portal/streamUpload3",
    assetId: action.assetId,
    data: action.data,
    chunkId: action.chunkId,
  };

  yield put(serverRequest(payload));
}

export default uploadv3;
